<template>
  <section v-if="agreement" class="application-create__form">
    <div class="container-xxxl">
      <div class="row">
        <div class="col-xxl-6 offset-xxl-3">
          <h3 class="application__form__title">{{ $lang.app.AGREEMENT }}</h3>
          <div class="application__form__block">
            <span v-if="isMainCustomerSignPending && !application.actions.some(action => action.constName === 'AGREEMENT_SIGN_ACTION')"
                  class="badge badge--orange mb1">{{ $lang.app.MAIN_CUSTOMER_SIGN_PENDING }}</span>
            <h4 class="add__fields__title space__between">
              {{ $lang.app.GENERATED_AGREEMENT }}
              <button v-if="application.actions.some(action => action.constName === 'AGREEMENT_SIGN_ACTION')" type="button"
                      class="button button--default button--bordered"
                      @click="$emitter.emit('open-sign-agreement-modal', {applicationId: application.id, agreementId: agreement.id})">
                {{ $lang.app.SIGN_DOCUMENT }}</button>
            </h4>
            <Loader v-if="!file" class="my-5"/>
            <div v-else class="docs__pdf w-full">
              <embed class="w-full h-full" :src="`data:application/pdf;toolbar=0&;base64,${file.base64}`">
            </div>
            <div class="panel mt2 mb0">
              <div v-for="(signer, index) in agreement.agreementSigners" :key="index" class="row">
                <div class="col-lg-9">
                  <div class="stack__list">
                    <div class="stack__label">{{ $lang.app.AGREEDS }}</div>
                    <div class="stack__value">{{ signer.fullName }} <br> <span class="text-gray-400 font-light">{{ signer.executorName }}</span></div>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="stack__list">
                    <div class="stack__label">{{ $lang.app.SIGNED_DATE }}</div>
                    <div v-if="signer.signDate" class="stack__value">
                      {{ $moment(signer.signDate).format('DD.MM.YYYY') }} <br>
                      {{ $moment(signer.signDate).format('HH:mm') }}
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <button v-if="this.application.actions.some(action => action.constName === 'APPLICANT_EDIT_ACTION')"
                    type="button" class="add__field__edit mt-4"
                    @click="handleAction('APPLICANT_EDIT_ACTION')">
              <svg viewBox="0 0 24 24" width="24" height="24">
                <use xlink:href="@/assets/v2/img/sprite.svg#icon__edit"></use>
              </svg>
              {{ $lang.app.EDIT }}
            </button>
          </div>
          <SignAgreementModal/>
        </div>
      </div>
      <div class="row mb-24">
        <div class="col-xxl-6 offset-xxl-3 mb-24">
          <h3 class="application__form__title">{{ $lang.app.ADDITIONAL_AGREEMENT }}</h3>
          <Loader v-if="loadingAdditionals"/>
          <div v-else class="pt-3">
            <Additional v-for="additional in additionals" :key="additional.id"
                        :agreement="agreement" :additional="additional"/>
          </div>
          <button v-if="actions.some(action => action.constName === 'APPLICANT_ADD_ADDITIONAL_AGREEMENT_ACTION')"
                  type="button" class="button button--default button--bordered button--full mb2"
                  @click="handleAction('APPLICANT_ADD_ADDITIONAL_AGREEMENT_ACTION')">
            <svg class="fill-current icon" viewBox="0 0 24 24" width="24" height="24">
              <use xlink:href="@/assets/v2/img/sprite.svg#icon__plus"></use>
            </svg>
            {{ actions.find(action => action.constName === 'APPLICANT_ADD_ADDITIONAL_AGREEMENT_ACTION').name }}
          </button>
          <AddAdditionalModal :agreement="agreement"/>
          <SignAdditionalAgreementModal/>
          <EditAdditionalAgreementModal/>
        </div>
      </div>
    </div>
  </section>
  <div class="application-create__controls" >
    <div class="container-fluid">
      <div class="application-create__controls__wrapper">
        <router-link :to="{name: 'ApplicantApplicationPlannersList', params: {applicationId: application.id}}"
                     class="button button--cancel">{{ $lang.app.CANCEL }}</router-link>
        <router-link v-if="application.applicationFile" :to="{
          name: 'ApplicantApplicationAppFileDetail',
          params: { appFileId: application.applicationFile?.id }
        }"
                     class="button button__icon--right">{{ $lang.app.NEXT }}
          <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
            <use xlink:href="@/assets/v2/img/sprite.svg#arrow__right"></use>
          </svg>
        </router-link>
        <router-link v-else :to="{name: 'ApplicantApplicationAppFileCreate'}"
                     class="button button__icon--right">{{ $lang.app.NEXT }}
          <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
            <use xlink:href="@/assets/v2/img/sprite.svg#arrow__right"></use>
          </svg>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import {loadAdditionalAgreements, getAgreementFile} from "../../../../api/applicant/application";
import SignAgreementModal from "../../../../components/applicant/application/modals/SignAgreementModal";
import Additional from "../../../../components/applicant/application/agreement/Additional.vue";
import AddAdditionalModal from "../../../../components/applicant/application/agreement/AddAdditionalModal.vue";
import SignAdditionalAgreementModal
  from "../../../../components/applicant/application/agreement/SignAdditionalAgreementModal.vue";
import EditAdditionalAgreementModal
  from "../../../../components/applicant/application/agreement/EditAdditionalAgreementModal.vue";

export default {
  name: "ApplicantApplicationAgreementDetail",
  components: {
    AddAdditionalModal,
    SignAdditionalAgreementModal,
    EditAdditionalAgreementModal,
    Additional,
    SignAgreementModal,
  },
  props: {
    application: Object
  },
  data() {
    return {
      loadingAdditionals: false,
      additionals: [],
      actions: [],
      file: null,
    }
  },
  computed: {
    agreement() {
      return this.application.agreement
    },
    isMainCustomerSignPending() {
      return !this.application.agreement.agreementSigners.find(s => s.firstSign).signDate
    },
  },
  created() {
    this.loadAdditionals()
    this.initFile()
  },
  watch: {
    'application.agreement'() {
      this.loadAdditionals()
      this.initFile()
    }
  },
  methods: {
    initFile() {
      if(this.agreement) {
        getAgreementFile(this.application.id, this.agreement.id)
            .then((response) => {
              this.file = response.data
            })
            .catch((error) => {
              this.$snotify.error(error);
            })
      }
    },
    handleAction(action) {
      switch (action) {
        case 'APPLICANT_EDIT_ACTION':
          this.$router.push({
            name: "ApplicantApplicationAgreementEdit",
            params: {
              applicationId: this.$route.params.applicationId,
              agreementId: this.agreement.id,
            },
          }); break;
        case 'APPLICANT_ADD_ADDITIONAL_AGREEMENT_ACTION':
          this.$emitter.emit('openAddAdditionalAgreementModal'); break;
      }
    },
    loadAdditionals() {
      if(this.agreement) {
        this.loadingAdditionals = true
        loadAdditionalAgreements(this.agreement.id).then(({results}) => {
          this.additionals = results.list
          this.actions = results.actions
        }).finally(() => {
          this.loadingAdditionals = false
        })
      }
    }
  },
  beforeMount() {
    this.$emitter.on('refreshAdditionalAgreements', () => {
      this.loadAdditionals()
    })
  },
  beforeUnmount() {
    this.$emitter.off('refreshAdditionalAgreements')
  },
};
</script>
